/**
 * Identity Platform Auth tenant ids keyed by CBT `school_id` (host slug).
 *
 * GCIP ids may differ from `school_id` (e.g. `demo` → `demo-p5ox2`). This map is
 * the canonical source for API pool selection, local CLIs (`sync:aimsis`,
 * `provision:auth`), and web sign-in pinning — not only Cloud Run env.
 *
 * `firestore.rules` restates `schoolUsesGcipTenant` / `gcipAuthTenantIdForSchool`
 * for the same schools — rules cannot import code. Keep the two in sync;
 * `api/src/lib/gcip-auth-tenant-mapping-consistency.test.ts` guards drift.
 */
export const GCIP_AUTH_TENANT_BY_SCHOOL_ID = {
    demo: 'demo-p5ox2',
};
/** Whether this school must provision and sign in via a dedicated GCIP tenant. */
export function schoolUsesGcipAuthPool(schoolId) {
    const slug = schoolId.trim();
    return Object.prototype.hasOwnProperty.call(GCIP_AUTH_TENANT_BY_SCHOOL_ID, slug);
}
/** GCIP tenant id for a school, or null when the school uses the default Auth pool. */
export function gcipAuthTenantIdForSchool(schoolId) {
    const slug = schoolId.trim();
    return GCIP_AUTH_TENANT_BY_SCHOOL_ID[slug] ?? null;
}
//# sourceMappingURL=school-gcip-tenant.js.map